var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { createUseStyles } from 'react-jss';
import { Icon, Dropdown } from '..';
import { useTheme } from '../../theme';
import { useMultipleMemoClasses, useMemoClasses } from '../../utils/hooks';
var useStyles = createUseStyles({
    primary: {
        '--RUI-menu-main': 'var(--RUI-color-primary)',
        '--RUI-menu-light': 'var(--RUI-color-primary-light)',
        '--RUI-menu-lighter': 'var(--RUI-color-primary-lighter)',
        '--RUI-menu-contrast': 'var(--RUI-color-primary-contrast)',
    },
    secondary: {
        '--RUI-menu-main': 'var(--RUI-color-secondary)',
        '--RUI-menu-light': 'var(--RUI-color-secondary-light)',
        '--RUI-menu-lighter': 'var(--RUI-color-secondary-lighter)',
        '--RUI-menu-contrast': 'var(--RUI-color-secondary-contrast)',
    },
    neutral: {
        '--RUI-menu-main': 'var(--RUI-color-neutral)',
        '--RUI-menu-light': 'var(--RUI-color-neutral-light)',
        '--RUI-menu-lighter': 'var(--RUI-color-neutral-lighter)',
        '--RUI-menu-contrast': 'var(--RUI-color-neutral-contrast)',
    },
    error: {
        '--RUI-menu-main': 'var(--RUI-color-error)',
        '--RUI-menu-light': 'var(--RUI-color-error-light)',
        '--RUI-menu-lighter': 'var(--RUI-color-error-lighter)',
        '--RUI-menu-contrast': 'var(--RUI-color-error-contrast)',
    },
    warning: {
        '--RUI-menu-main': 'var(--RUI-color-warning)',
        '--RUI-menu-light': 'var(--RUI-color-warning-light)',
        '--RUI-menu-lighter': 'var(--RUI-color-warning-lighter)',
        '--RUI-menu-contrast': 'var(--RUI-color-warning-contrast)',
    },
    success: {
        '--RUI-menu-main': 'var(--RUI-color-success)',
        '--RUI-menu-light': 'var(--RUI-color-success-light)',
        '--RUI-menu-lighter': 'var(--RUI-color-success-lighter)',
        '--RUI-menu-contrast': 'var(--RUI-color-success-contrast)',
    },
    base: {
        backgroundColor: 'var(--RUI-menu-main)',
        color: 'var(--RUI-menu-contrast)',
        padding: 'var(--RUI-padding)',
        margin: 'var(--RUI-margin)',
        font: 'var(--RUI-font-body1)',
        display: 'flex',
        alignItems: 'center',
        '&:focus': {
            backgroundColor: 'var(--RUI-menu-light)',
        },
    },
    baseOverrides: function (theme) { return (__assign({}, theme.overrides.Menu.base)); },
    list: {
        backgroundColor: 'white',
        listStyle: 'none',
        padding: 'calc(0.5 * var(--RUI-padding)) 0',
        margin: 0,
        border: 'var(--RUI-border-width) solid var(--RUI-color-neutral-darker)',
        font: 'var(--RUI-font-body1)',
        display: 'flex',
        flexDirection: 'column',
    },
    listOverrides: function (theme) { return (__assign({}, theme.overrides.Menu.list)); },
    item: {
        width: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 'calc(0.5 * var(--RUI-padding))',
        backgroundColor: 'white',
        color: 'black',
        '&:hover': {
            backgroundColor: 'var(--RUI-color-neutral-lighter)',
        },
        '&:focus': {
            outline: 'none',
            backgroundColor: 'var(--RUI-menu-main)',
            color: 'var(--RUI-menu-contrast)',
        },
    },
    itemOverrides: function (theme) { return (__assign({}, theme.overrides.Menu.item)); },
    postIcon: {},
    postIconOverrides: function (theme) { return (__assign({}, theme.overrides.Menu.postIcon)); },
    preIcon: {},
    preIconOverrides: function (theme) { return (__assign({}, theme.overrides.Menu.preIcon)); },
    link: {
        cursor: 'pointer',
        textDecoration: 'none',
        width: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 'calc(0.5 * var(--RUI-padding))',
        backgroundColor: 'white',
        color: 'black',
        '&:hover': {
            backgroundColor: 'var(--RUI-color-neutral-lighter)',
        },
        '&:focus': {
            outline: 'none',
            backgroundColor: 'var(--RUI-menu-main)',
            color: 'var(--RUI-menu-contrast)',
        },
    },
    linkOverrides: function (theme) { return (__assign({}, theme.overrides.Menu.link)); },
    itemText: {},
    itemTextOverrides: function (theme) { return (__assign({}, theme.overrides.Menu.itemText)); },
    itemPostIcon: {},
    itemPostIconOverrides: function (theme) { return (__assign({}, theme.overrides.Menu.itemPostIcon)); },
    itemPreIcon: {},
    itemPreIconOverrides: function (theme) { return (__assign({}, theme.overrides.Menu.itemPreIcon)); },
    round: {
        borderRadius: 'var(--RUI-border-radius)',
    },
    roundOverrides: function (theme) { return (__assign({}, theme.overrides.Menu.round)); },
}, { name: 'RUIMenu' });
var instaceOfMenuItem = function (object) {
    return !!object.text;
};
var Menu = function (_a) {
    var color = _a.color, className = _a.className, items = _a.items, preIcon = _a.preIcon, postIcon = _a.postIcon, title = _a.title, hover = _a.hover, round = _a.round, position = _a.position, props = __rest(_a, ["color", "className", "items", "preIcon", "postIcon", "title", "hover", "round", "position"]);
    var theme = useTheme();
    var styles = useStyles(theme);
    var baseClasses = useMemoClasses([
        styles.base,
        styles[color],
        round && styles.round,
        theme.overrides.Menu.base && styles.baseOverrides,
        theme.overrides.Menu.round && styles.roundOverrides,
        'RUIMenu-base',
        className,
    ], [theme, className, color]);
    var listClasses = useMemoClasses([styles.list, theme.overrides.Menu.list && styles.listOverrides, styles[color], 'RUIMenu-list'], [theme, color]);
    var _b = useMultipleMemoClasses([
        [styles.link, theme.overrides.Menu.link && styles.linkOverrides, 'RUIMenu-link'],
        [styles.itemText, theme.overrides.Menu.itemText && styles.itemTextOverrides, 'RUIMenu-itemText'],
        [styles.itemPreIcon, theme.overrides.Menu.itemPreIcon && styles.itemPreIconOverrides, 'RUIMenu-itemPreIcon'],
        [styles.itemPostIcon, theme.overrides.Menu.itemPostIcon && styles.itemPostIconOverrides, 'RUIMenu-itemPostIcon'],
        [styles.item, theme.overrides.Menu.item && styles.itemOverrides, 'RUIMenu-item'],
        [styles.preIcon, theme.overrides.Menu.preIcon && styles.preIconOverrides, 'RUIMenu-preIcon'],
        [styles.postIcon, theme.overrides.Menu.postIcon && styles.postIconOverrides, 'RUIMenu-postIcon'],
    ], [theme]), linkClasses = _b[0], itemTextClasses = _b[1], itemPreIconClasses = _b[2], itemPostIconClasses = _b[3], itemClasses = _b[4], preIconClasses = _b[5], postIconClasses = _b[6];
    var containerMenu = (React.createElement("div", __assign({ className: baseClasses, tabIndex: 0 }, props),
        preIcon && React.createElement(Icon, { className: preIconClasses }, preIcon),
        title,
        postIcon && React.createElement(Icon, { className: postIconClasses }, postIcon)));
    var window = items ? (React.createElement("ul", { className: listClasses, role: "menu" }, items.map(function (item, index) {
        return instaceOfMenuItem(item) ? (item.link ? (React.createElement("a", { className: linkClasses, key: index, tabIndex: 0, href: item.link },
            item.preIcon && React.createElement(Icon, { className: itemPreIconClasses }, item.preIcon),
            item.text,
            item.postIcon && React.createElement(Icon, { className: itemPostIconClasses }, item.postIcon))) : (React.createElement("li", { key: index, className: itemClasses, tabIndex: 0, role: "menuitem", onClick: item.callback },
            item.preIcon && React.createElement(Icon, { className: itemPreIconClasses }, item.preIcon),
            React.createElement("span", { className: itemTextClasses }, item.text),
            item.postIcon && React.createElement(Icon, { className: itemPostIconClasses }, item.postIcon)))) : (item);
    }))) : null;
    return (React.createElement(Dropdown, { baseNode: containerMenu, mode: ['keyboard', hover ? 'hover' : 'click'], windowNode: window, position: position }));
};
Menu.defaultProps = {
    title: null,
    color: 'primary',
    items: null,
    preIcon: '',
    postIcon: '',
    hover: false,
    round: false,
    position: 'bottom',
};
export { Menu as default, Menu };
